import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
export const OverviewCard = ({ workspace }) => {
    const { t } = useTranslation();
    const roleLabel = workspace.role === 'OWNER'
        ? t('owner')
        : workspace.role === 'MEMBER'
            ? t('member')
            : (workspace.role ?? t('unknown'));
    const copyPublicId = React.useCallback(() => {
        navigator.clipboard
            .writeText(workspace.publicId)
            .then(() => toast.success(t('copied')))
            .catch(() => toast.error(t('copy_failed', { ns: 'error' })));
    }, [t, workspace.publicId]);
    return (<Card>
            <CardHeader>
                <CardTitle className="text-base md:text-lg">{t('workspaces.overview', { ns: 'glossary' })}</CardTitle>
            </CardHeader>
            <CardContent className="space-y-6">
                {/* Public ID */}
                <div className="space-y-1">
                    <Label className="text-xs uppercase text-muted-foreground">{t('public_id')}</Label>
                    <div className="flex items-center gap-2">
                        <Input value={workspace.publicId} readOnly className="font-mono text-xs"/>
                        <Button variant="outline" size="sm" type="button" onClick={copyPublicId}>
                            {t('copy')}
                        </Button>
                    </div>
                    <p className="text-xs text-muted-foreground">
                        {t('workspaces.public_id.help', { ns: 'glossary' })}
                    </p>
                </div>

                {/* Role */}
                <div className="space-y-1">
                    <Label className="text-xs uppercase text-muted-foreground">
                        {t('workspaces.your_role', { ns: 'glossary' })}
                    </Label>
                    <p className="text-sm">{roleLabel}</p>
                    <p className="text-xs text-muted-foreground">{t('workspaces.role.help', { ns: 'glossary' })}</p>
                </div>
            </CardContent>
        </Card>);
};
